export default __webpack_public_path__ + "static/media/group.bb89f12c.jpg";